export default "__VITE_ASSET__De8xAbMC__"